import { render } from "./NewTabContentView.vue?vue&type=template&id=518e57f6&scoped=true"
import script from "./NewTabContentView.vue?vue&type=script&lang=js"
export * from "./NewTabContentView.vue?vue&type=script&lang=js"

import "./NewTabContentView.vue?vue&type=style&index=0&id=518e57f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518e57f6"]])

export default __exports__